import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ValidationMessages } from '../validation-messages';
import { HelperService } from '../services/helperClass.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css', '../../assets/css/bootstrap.css', '../../assets/css/default.css', '../../assets/css/AdminLTE.css', '../../assets/css/_all-skins.css', '../../assets/css/fSelect.css', '../../assets/datatables.net/dataTables.bootstrap.css']
})
export class FooterComponent implements OnInit {

  domainname = "";
  currentTime:any;
  year:any;
  requestURL: string;
  constructor(
    public router: Router, 
    private helperService: HelperService) 
  {
    this.currentTime = new Date();
    this.year = this.currentTime.getFullYear();    
    this.requestURL = this.helperService.getViewformEndpoint();    
   }
  

  ngOnInit() {

    if (localStorage.getItem('wholesalerInfoObJ') !== null) {
      let wholesalerInfoArray = JSON.parse(localStorage.getItem('wholesalerInfoObJ'));
      if (wholesalerInfoArray.output == 'success') {
        this.domainname = wholesalerInfoArray.wholesalerInfo[0].wi_domain;
        if (this.domainname == ValidationMessages.stagingNormandyDomain || this.domainname == ValidationMessages.productionNormandyDomain || this.domainname == ValidationMessages.localNormandyDomain ) {
            this.domainname = 'normandy';
        }
        if (this.domainname == ValidationMessages.stagingCanopyDomain || this.domainname == ValidationMessages.productionCanopyDomain) {
          this.domainname = 'canopy';
        }
        if (this.domainname == ValidationMessages.stagingPbibinsDomain || this.domainname == ValidationMessages.productionPbibinsDomain ) {
          this.domainname = 'pbibins';
        }
        if (this.domainname == ValidationMessages.stagingboldpenguinDomain || this.domainname == ValidationMessages.productionboldpenguinDomain ) {
          this.domainname = 'boldpenguin';
        }

      }
   }
  }
  
    openDoc(type: number){
        let docUrl = '';
        if(type == 1){
            docUrl = this.requestURL + 'sPrivacy.pdf';
            window.open(docUrl, "_blank");
        } else {
            docUrl = this.requestURL + 'sTerms.pdf';
            window.open(docUrl, "_blank");
        }
    }
}
